import { Component } from '@angular/core';

@Component({
    selector: 'ui-progress-bar',
    imports: [],
    templateUrl: './progress-bar.component.html',
    styleUrl: './progress-bar.component.scss'
})
export class ProgressBarComponent {

}
